import { FC } from "react";
import { ConfigurationListItem, ConfigurationListItemKind } from "../configuration.types";
import {
  RowContainer,
  RowLeft,
  RowTitle,
  RowDescription,
  RowRight,
  RowRightColumn,
} from "../configuration.styles";
import { MDSButton, MDSButtonVariant, MDSTextVariant, MDSTextWeight } from "@/mds";
import styled from "@emotion/styled";

export const ConfigurationListButtonRow: FC<
  Extract<ConfigurationListItem, { kind: ConfigurationListItemKind.Button }>
> = ({ title, description, variant, actionLabel, onClick }) => {
  const buttonVariant = variant ?? MDSButtonVariant.Default;

  return (
    <RowContainer>
      <RowLeft>
        <RowTitle variant={MDSTextVariant.ParagraphSm} weight={MDSTextWeight.Medium}>
          {title}
        </RowTitle>
        {description ? (
          <RowDescription variant={MDSTextVariant.TextS}>{description}</RowDescription>
        ) : null}
      </RowLeft>
      <RowRight>
        <RowRightColumn>
          <ActionButton variant={buttonVariant} onClick={onClick}>
            {actionLabel}
          </ActionButton>
        </RowRightColumn>
      </RowRight>
    </RowContainer>
  );
};

const ActionButton = styled(MDSButton)`
  min-width: 140px;
`;
